const ERROR_SELECTOR = '.Mui-error, [aria-invalid="true"], [data-form-error="true"]'

/**
 * Scrolls to the first field in error of the page (or of `container`).
 * Waits for the next paint so that error states set just before the call are rendered.
 */
export const scrollToFirstError = (container?: ParentNode | null) => {
  if (typeof window === 'undefined') return
  window.requestAnimationFrame(() => {
    const target = (container ?? document).querySelector<HTMLElement>(ERROR_SELECTOR)
    target?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  })
}
